/**
 * GENERATED — do not edit by hand.
 *
 * The newest Overture "extras" PMTiles release, resolved from the bucket listing
 * by scripts/resolve-overture-release.mjs (npm run overture:resolve, and the
 * `prebuild` hook before every `npm run build`). Committed with a known-good
 * value so dev and CI always have a release even if the listing is unreachable.
 *
 * Overture retains only the two most recent releases and rotates them, so a
 * hardcoded date goes stale silently (BUG-070). This file is refreshed at build
 * time instead. Override at runtime with VITE_OVERTURE_RELEASE.
 */
export const RESOLVED_OVERTURE_RELEASE = '2026-10-21.0'
